<div class="w-full h-full">
    <app-tab-header [tabs]="tabs">
        <span 
            matTooltip="Export to Excel" 
            matTooltipPosition="left" 
            matTooltipClass="custom-orange-tooltip">
            <app-print-button (togglePrint)="print()"></app-print-button>
        </span>
    </app-tab-header>
    <div class="w-900-px mx-auto">
        <form [formGroup]="form">
            <div class="grid grid-cols-12 gap-3">
                <div class="col-span-6">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <app-date-input class="w-full" label="Date From:" [parentForm]="form" controlName="dateFrom"></app-date-input>
                    </div>
                </div>
                <div class="col-span-6">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <app-date-input class="w-full" label="Date To:" [parentForm]="form" controlName="dateTo"></app-date-input>
                    </div>
                </div>
            </div>
        </form>
        <div class="w-full flex items-center justify-center mt-10 mb-4">
            <button (click)="submit()" class="uppercase custom-btn btn-dark-orange font-semibold text-xs px-6 py-2">
                submit
            </button>
        </div>
    </div>

    <div *ngIf="showTable">
        <div *ngIf="submitted">
            <app-table-controls
                [currentLimit]="activeLimit?.size ?? 10"
                [showLimitControl]="true"
                [showSearchControl]="true"
                (limitChangeEvent)="activeLimit?.onLimitChange($event)"
                (searchKeyupEvent)="activeSearch?.onSearchKeyup($event)"
                (keydownEvent)="keyDownFunction($event)"
            ></app-table-controls>

            <div class="bg-light-orange w-full maxh-550-px px-3 overflow-x-auto w-table">
                <div class="data-table4 mt-3 barlow text-xs" style="font-size: 10px;">
                    <table class="w-full">
                        <thead>
                            <tr>
                                <th class="text-left barlow pl-2 pt-3 pb-3">
                                    DATE / TIME
                                    <img src="../../../../assets/images/icon/sort2.webp" style="height:20px;float:right" (click)="sortList('date')">
                                </th>
                                <th class="text-left barlow pl-2 pt-3 pb-3">
                                    CASH IN
                                    <img src="../../../../assets/images/icon/sort2.webp" style="height:20px;float:right" (click)="sortList('cashIn')">
                                </th>
                                <th class="text-left barlow pl-2 pt-3 pb-3">
                                    SCAN QR
                                    <img src="../../../../assets/images/icon/sort2.webp" style="height:20px;float:right" (click)="sortList('scanQr')">
                                </th>
                                <th class="text-left barlow pl-2 pt-3 pb-3">
                                    TRANSFER FUNDS
                                    <img src="../../../../assets/images/icon/sort2.webp" style="height:20px;float:right" (click)="sortList('transferFunds')">
                                </th>
                                <th class="text-left barlow pl-2 pt-3 pb-3">
                                    RECEIVE MONEY
                                    <img src="../../../../assets/images/icon/sort2.webp" style="height:20px;float:right" (click)="sortList('receiveMoney')">
                                </th>
                                <th class="text-left barlow pl-2 pt-3 pb-3">
                                    BUY LOAD
                                    <img src="../../../../assets/images/icon/sort2.webp" style="height:20px;float:right" (click)="sortList('buyLoad')">
                                </th>
                                <th class="text-left barlow pl-2 pt-3 pb-3">
                                    PAY BILLS
                                    <img src="../../../../assets/images/icon/sort2.webp" style="height:20px;float:right" (click)="sortList('payBills')">
                                </th>
                                <th class="text-left barlow pl-2 pt-3 pb-3">
                                    BUY LOAD CASH BACK
                                    <img src="../../../../assets/images/icon/sort2.webp" style="height:20px;float:right" (click)="sortList('buyloadCashback')">
                                </th>
                                <th class="text-left barlow pl-2 pt-3 pb-3">
                                    BALANCE OF ALL USERS
                                    <img src="../../../../assets/images/icon/sort2.webp" style="height:20px;float:right" (click)="sortList('balanceOfAllUsers')">
                                </th>
                                <th class="text-left barlow pl-2 pt-3 pb-3">
                                    CURRENT/TOTAL USERS
                                    <img src="../../../../assets/images/icon/sort2.webp" style="height:20px;float:right" (click)="sortList('currentTotalUsers')">
                                </th>
                                <th class="text-left barlow pl-2 pt-3 pb-3">
                                    ANDRIOD/IOS
                                    <img src="../../../../assets/images/icon/sort2.webp" style="height:20px;float:right" (click)="sortList('androidIos')">
                                </th>
                                <th class="text-left barlow pl-2 pt-3 pb-3">
                                    NO. OF TRANSACTIONS
                                    <img src="../../../../assets/images/icon/sort2.webp" style="height:20px;float:right" (click)="sortList('numberOfTransactions')">
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="focus:outline-none" *ngFor="let item of activeList">
                                <td>{{ item.date | date:'yyyy-MM-dd' }}</td>
                                <td>{{ item.cashIn ?? '-' }}</td>
                                <td>{{ item.scanQr ?? '-' }}</td>
                                <td>{{ item.transferFunds ?? '-' }}</td>
                                <td>{{ item.receiveMoney ?? '-' }}</td>
                                <td>{{ item.buyLoad ?? '-' }}</td>
                                <td>{{ item.payBills ?? '-' }}</td>
                                <td>{{ item.buyloadCashback ?? '-' }}</td>
                                <td>{{ item.balanceOfAllUsers ?? '-' }}</td>
                                <td>{{ item.currentTotalUsers ?? '-' }}</td>
                                <td>{{ item.androidIos ?? '-' }}</td>
                                <td>{{ item.numberOfTransactions ?? '-' }}</td>
                            </tr>

                            <!-- Loading state -->
                            <tr *ngIf="isLoadingData">
                                <td colspan="12" class="text-center py-10 text-gray-500">
                                    <div class="flex flex-col items-center justify-center gap-2">
                                        <span class="italic text-xs">Loading data, please wait...</span>
                                    </div>
                                </td>
                            </tr>

                            <!-- Empty state (only shown after loading completes) -->
                            <tr *ngIf="!isLoadingData && (!activeList || activeList.length === 0)">
                                <td colspan="12" class="text-center py-10 text-gray-500">
                                    <div class="flex flex-col items-center justify-center gap-2">
                                        <img src="../../../../assets/images/icon/no-data.webp"
                                            alt="No Data"
                                            style="height: 48px; opacity: 0.4;"
                                            onerror="this.style.display='none'">
                                        <span class="font-semibold text-xs uppercase tracking-wide">No records found</span>
                                        <span class="italic text-xs">Try adjusting your search or filter criteria.</span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <app-pagination
                backgroundColor="bg-light-orange"
                [showTotalEntries]="true"
                [currentPage]="activePage?.current ?? 1"
                [totalPages]="activePage?.total ?? 1"
                [pageSize]="activeLimit?.size ?? 10"
                [totalItems]="activeLimit?.total ?? 0"
                (previousPage)="prevPage()"
                (nextPage)="nextPage()"
                (pageChange)="setPage($event)"
            ></app-pagination>
        </div>
    </div>
</div>
<ngx-spinner type="border" size="medium">
    <app-megapay-loader></app-megapay-loader>
</ngx-spinner>